import { CSSProperties, PropsWithChildren } from "react";
import {
  resolutionIdentitiesContext,
  useResolutionIdentifiers,
  useResolutionIdentitiesContext,
} from "./useResolutionIdentities";
import { IntegrationIcon } from "src/components/IntegrationIcon";
import { Flex } from "src/components/Flex";

export const Identities = (
  props: PropsWithChildren<{
    orgId: string;
    entityUuid: string;
  }>
) => {
  const identities = useResolutionIdentifiers({
    orgId: props.orgId,
    entityUuid: props.entityUuid,
  });
  return (
    <resolutionIdentitiesContext.Provider value={identities}>
      {props.children}
    </resolutionIdentitiesContext.Provider>
  );
};

export const IdentitiesComponent = (props: { style?: CSSProperties }) => {
  const context = useResolutionIdentitiesContext();
  const { query } = context;
  if (!query.isFetched) {
    query.refetch();
  }
  const cleaned =
    query.data?.source?.filter((item: any) => item.name && item.integration) ||
    [];
  return (
    <div className="entity" style={props.style}>
      {query.isLoading && <div>Loading...</div>}
      {cleaned.map((item: any, index: number) => (
        <Flex
          key={index}
          start
          style={{ alignItems: "center", lineHeight: "24px" }}
        >
          <IntegrationIcon
            source={item.integration}
            style={{
              height: "24px",
              display: "flex",
              alignItems: "center",
              marginRight: "5px",
            }}
          />
          <div className="trunc">{item.name}</div>
        </Flex>
      ))}
    </div>
  );
};
